import type { Dispatch } from 'react';

import type { NotificationsAction } from 'src/notifications';
import { NotificationsActionType } from 'src/notifications';
import { Sentry } from 'src/sentry';
import { v4 as uuid4 } from 'uuid';

import { REPOSITORY_DROPZONE_SENTRY_FEATURE } from '../../RepositoryDropzoneConfig';

export function notifyRepositoryDropzoneError(
  dispatch: Dispatch<NotificationsAction>,
  error: unknown,
  message: string
): void {
  Sentry.captureException(error, {
    tags: { feature: REPOSITORY_DROPZONE_SENTRY_FEATURE },
  });
  dispatch({
    payload: {
      key: uuid4(),
      message,
      variant: 'error',
    },
    type: NotificationsActionType.PUSH_NOTIFICATION,
  });
}
